import styled from "styled-components";


export const Title = styled.div`
  display: flex;
  width: 100%;
  background-color: ${(props) => props.color ?? "white"};
  color: #fff;
  height: 40px;
  align-items: center;
  border: 1px solid var(--border-color);
  border-bottom: none;
  text-align: center;
  justify-content: center;
`;

export const CellMatrix = styled.div<{opacity: number, background : string, active: boolean}>`
  display: flex;
  width: 100%;
  align-items: center;
  border: 1px solid var(--border-color);
  cursor: pointer;
  height: 42px;
  max-width: 20%;
  transition: 200ms ease;
  background-color: ${(props) => props.background ?? "white"};
  opacity: ${(props) => props.opacity ?? 1};
  color: #fff;
  flex: 0 0 20%;
  justify-content: center;
  &:hover{
    opacity: 0.7;
  }

  ${(props) => props.active && `
    font-weight: bold;
    transform: scale(1.1);
    opacity: 1;
    z-index: 2;
    &:hover{
      opacity: 1;
    }
  `};

`;

export const WrapCellsMatrix = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
  max-width: calc(100% - 120px);
  flex: 0 0 calc(100% - 120px);
  justify-content: center;
`;

export const WrapCellsDescriptionVertical = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  align-items: center;
  border: 1px solid var(--border-color);
  flex-direction: column;
  border-left: 0;
  border-right: 0;
  flex: 0 0 80px;
`;

export const WrapCellsDescriptionHorizontal = styled.div`
    align-items: center;
    border-right: 1px solid var(--border-color);
    border-top: 0;
    display: flex;
    flex: 0 0 calc(100% - 120px);
    justify-content: center;
    max-width: calc(100% - 120px);
`;

export const CellDescriptionVertical = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex: 0 0 40px;
  border-top: 1px solid var(--border-color);
  justify-content: center;
`;

export const CellDescriptionHorizontall = styled.div`
  align-items: center;
  border: 1px solid var(--border-color);
  border-bottom: 0;
  border-right: 0;
  border-top: 0;
  display: flex;
  flex: 0 0 20%;
  height: 40px;
  max-width: 20%;
  justify-content: center;
  text-align: center;
`;

export const VerticalTitle = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex: 0 0 40px;
  border: 1px solid var(--border-color);
  background-color: var(--grey);
  color: #fff;
  justify-content: center;
  span {
    transform: scale(-1); 
    writing-mode: vertical-lr;
  }
`;

export const Spacer = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 120px;
  height: 40px;
  justify-content: center;
  max-width: 120px;
`;


export const TitleHorizontal = styled.div<{spacer: number}>`
  display: flex;
  width: 100%;
  background-color: ${(props) => props.color ?? "white"};
  color: #fff;
  height: 40px;
  align-items: center;
  border: 1px solid var(--border-color);
  border-bottom: none;
  text-align: center;
  justify-content: center;
  flex: 0 0 calc(100% - ${(props) => props.spacer > 1 ? "240px": "120px"});
`;
